import { createFileRoute, Link } from '@tanstack/react-router'
import { ChevronLeft } from 'lucide-react'
import { ConversationDetail } from '@/components/conversations/conversation-detail'

export const Route = createFileRoute(
  '/_authenticated/conversations/$conversationId',
)({
  component: ConversationDetailPage,
})

function ConversationDetailPage() {
  const { conversationId } = Route.useParams()
  return (
    <div className="p-4 md:p-8 max-w-4xl mx-auto flex flex-col h-[calc(100vh-4rem)]">
      {/* Back link */}
      <Link
        to="/conversations"
        className="flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground mb-4"
        aria-label="Back to conversations list"
      >
        <ChevronLeft className="w-4 h-4" />
        Back to Conversations
      </Link>

      <ConversationDetail conversationId={conversationId} />
    </div>
  )
}
